import React, { FC, useState, useEffect, useCallback } from 'react'
import { Checkbox } from '@wmgtech/legato'

import { FilterArchivedProps } from './FilterArchived.props'
import './FilterArchived.scss'

const FilterArchived: FC<FilterArchivedProps> = ({ initialValue, onSelect, onReset, reset }) => {
  const [currentValue, setCurrentValue] = useState<string>(initialValue || 'hide')

  const selectValue = useCallback(() => setCurrentValue(currentValue === 'hide' ? 'show' : 'hide'), [currentValue])

  useEffect(() => {
    if (currentValue) onSelect(currentValue)
  }, [currentValue, onSelect, initialValue])

  useEffect(() => {
    if (reset) {
      onReset()
      setCurrentValue('hide')
    }
  }, [reset, onReset])

  return (
    <div className="filter-archived">
      <Checkbox
        className="filter-archived__checkbox"
        label="Show Archived"
        onChange={selectValue}
        checked={currentValue === 'show'}
      />
    </div>
  )
}

export default FilterArchived
